<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import WrongRecipientSourceCleanupInstructionsCell from "./_modules/wrong-recipient-source-cleanup-instructions-cell"
  import type {
    WrongRecipientSourceCleanupDraft,
    WrongRecipientSourceCleanupRow,
  } from "../../contract"

  let props: InboxWorkflowCellProps<
    WrongRecipientSourceCleanupRow,
    WrongRecipientSourceCleanupDraft
  > = $props()

  const row = $derived(props.row)
</script>

<WrongRecipientSourceCleanupInstructionsCell
  instructions={row.sourceCleanupInstructions}
  note={row.sourceCleanupNote}
  disabled={props.disabled}
/>
